import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingContainerService } from '@edassist/shared';

@Component({
	selector: 'ea-button-spinner',
	templateUrl: './button-spinner.component.html',
	styleUrls: ['./button-spinner.component.scss']
})
export class ButtonSpinnerComponent implements OnInit, OnDestroy {
	@Input() isSubmitting = false;

	private readonly subscriptions: Subscription = new Subscription();

	constructor(
		private readonly loadingContainerService: LoadingContainerService
	) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.loadingContainerService.hideLoadersEvent.subscribe(() => {
				// Stop all submission spinners in the case of a global error just in case
				this.isSubmitting = false;
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
